import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "../lib/supabaseClient";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function ArtistQuoteForm({ prefill }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    artist: "",
    medium: "huile",
    average_value: "",
    price_per_m2: "",
    notes: "",
  });

  // Pré-remplissage depuis l'aide à la cotation (n'écrase que les champs fournis).
  useEffect(() => {
    if (!prefill) return;
    setForm((prev) => ({ ...prev, ...prefill }));
  }, [prefill]);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSuccess(false);
    setError(null);

    const { error: insertError } = await supabase.from("artist_quotes").insert([{ ...form }]);
    if (insertError) {
      setError(t("artistQuoteTools.quoteForm.error", { message: insertError.message }));
    } else {
      setSuccess(true);
      setForm({ artist: "", medium: "huile", average_value: "", price_per_m2: "", notes: "" });
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">📝 {t("artistQuoteTools.quoteForm.title")}</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          name="artist"
          placeholder={t("artistQuoteTools.common.artistPlaceholder")}
          value={form.artist}
          onChange={handleChange}
          required
        />

        <select name="medium" value={form.medium} onChange={handleChange} className="form-control-artsy">
          {["huile", "aquarelle", "dessin", "sculpture"].map((key) => (
            <option key={key} value={key}>{t(`artistQuoteTools.mediums.${key}`)}</option>
          ))}
        </select>

        <Input
          name="average_value"
          type="number"
          placeholder={t("artistQuoteTools.quoteForm.averageValue")}
          value={form.average_value}
          onChange={handleChange}
          required
        />

        <Input
          name="price_per_m2"
          type="number"
          placeholder={t("artistQuoteTools.quoteForm.pricePerSqM")}
          value={form.price_per_m2}
          onChange={handleChange}
        />

        <textarea
          name="notes"
          placeholder={t("artistQuoteTools.quoteForm.notesPlaceholder")}
          value={form.notes}
          onChange={handleChange}
          className="w-full border p-2 rounded min-h-[80px]"
        />

        <Button type="submit">📤 {t("artistQuoteTools.quoteForm.save")}</Button>

        {success && <p className="text-green-600">{t("artistQuoteTools.quoteForm.success")}</p>}
        {error && <p className="text-red-600">{error}</p>}
      </form>
    </div>
  );
}
